export const METRIKA_COUNTER_ID = 111455219;

export const METRIKA_GOALS = {
  REGISTRATION: 'registration',
  BUSINESS: 'business',
  AFFILIATE_PROGRAM: 'affiliate_program',
  PARTNER_PROGRAM_FORM: 'partner_program_form',
  SEND_INVITATIONS: 'send_invitations',
  BUSINESS_INDIVIDUAL: 'Business_Individual',
  BUSINESS_LEGAL: 'Business_legalentity',
  INDIVIDUAL_TO_TOP_UP: 'Individual_to_top_up',
  INDIVIDUAL_TO_TOP_UP_FORM: 'Individual_to_top_up_form',
  INDIVIDUAL_CABINET_COMPLETED: 'Individual_Uabinet_completed',
  BUSINESS_TO_TOP_UP: 'Business_to_top_up',
  BUSINESS_TO_TOP_UP_FORM: 'Business_to_top_up_form',
  BUSINESS_CABINET_COMPLETED: 'Business_Uabinet_completed',
};

function getYaCounter() {
  if (typeof window === 'undefined' || !window.Ya || !window.Ya._metrika) {
    return null;
  }

  const counters = window.Ya._metrika.counters || {};
  return (
    counters[`${METRIKA_COUNTER_ID}:0`] ||
    counters[METRIKA_COUNTER_ID] ||
    window.Ya._metrika.counter ||
    null
  );
}

export function reachMetrikaGoal(vm, goal) {
  if (!goal) {
    return;
  }

  try {
    const yaCounter = getYaCounter();
    if (yaCounter && typeof yaCounter.reachGoal === 'function') {
      yaCounter.reachGoal(goal);
      return;
    }

    if (typeof window !== 'undefined' && typeof window.ym === 'function') {
      window.ym(METRIKA_COUNTER_ID, 'reachGoal', goal);
      return;
    }

    if (vm && vm.$metrika && typeof vm.$metrika.reachGoal === 'function') {
      vm.$metrika.reachGoal(goal);
    }
  } catch (e) {
    // Metrika should never break UX
    console.warn('Yandex Metrika reachGoal failed:', goal, e);
  }
}

export function isActiveAccountLegal(store) {
  const activeAccount = store && store.state && store.state.Auth && store.state.Auth.activeAccount;
  return !!(activeAccount && activeAccount.is_legal);
}

export function reachBusinessTypeGoal(vm, isLegal) {
  reachMetrikaGoal(vm, isLegal ? METRIKA_GOALS.BUSINESS_LEGAL : METRIKA_GOALS.BUSINESS_INDIVIDUAL);
}

export function reachTopUpClickGoal(vm, store) {
  reachMetrikaGoal(
    vm,
    isActiveAccountLegal(store)
      ? METRIKA_GOALS.BUSINESS_TO_TOP_UP
      : METRIKA_GOALS.INDIVIDUAL_TO_TOP_UP
  );
}

export function reachTopUpFormGoal(vm, store) {
  reachMetrikaGoal(
    vm,
    isActiveAccountLegal(store)
      ? METRIKA_GOALS.BUSINESS_TO_TOP_UP_FORM
      : METRIKA_GOALS.INDIVIDUAL_TO_TOP_UP_FORM
  );
}

export function reachCabinetCompletedGoal(vm, store) {
  reachMetrikaGoal(
    vm,
    isActiveAccountLegal(store)
      ? METRIKA_GOALS.BUSINESS_CABINET_COMPLETED
      : METRIKA_GOALS.INDIVIDUAL_CABINET_COMPLETED
  );
}
